// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 962 ? "home" : chunkId) + "-legacy." + {"198":"8cb1b4a8","270":"5ba4f306","500":"e009f7c2","541":"5041e446","585":"0cb8b64e","796":"104a0ad7","899":"842e8af5","962":"15c78a52"}[chunkId] + ".js";
};